<div class="filters row">
    <div class="row">
        <div class="r-form-group">
            <label class="title">{{'LIDS.SEARCH' |translate}}</label>
            <input [(ngModel)]="freeSearch" type="text" pInputText size="50"
                placeholder="{{'BUSINESS_MANAGEMENT.FREE_SEARCH' |translate}}" (delayEvent)="filterfreeSearch()"
                delayEventName="onkeyup">
        </div>
        <!-- <div class="r-form-group">
            <label class="title">{{'LIDS.SEARCH' |translate}}</label>
            <input [(ngModel)]="packageName" type="text" pInputText size="50"
                placeholder="{{'BUSINESS_MANAGEMENT.PACKAGE_NAME_SEARCH' |translate}}"
                (delayEvent)="filterPackageName()" delayEventName="onkeyup">
        </div> -->
        <div class="r-form-group">
            <label class="title">{{'BUSINESS_MANAGEMENT.FILTER_BY_PACKAGE' |translate}}</label>
            <p-dropdown [options]="packageNames" [(ngModel)]="selectedPackage" optionLabel="label"
              placeholder="{{'BUSINESS_MANAGEMENT.ALL_PACKAGES' |translate}}" [showClear]="true" (onClear)="selectPackage()"
              (onChange)="selectPackage()"></p-dropdown>
          </div>
        <div class="r-form-group">
            <label class="title">{{'BUSINESS_MANAGEMENT.SEARCH_SOURCE' | translate}}</label>
            <p-dropdown [options]="translatedSourceOptions" [(ngModel)]="businessSource" optionLabel="label"  optionValue="value"
                placeholder="{{'BUSINESS_MANAGEMENT.SEARCH_SOURCE' | translate}}" [showClear]="true" (onClear)="filterSource()"
                (onChange)="filterSource()">
            </p-dropdown>
        </div>

    </div>
</div>
    <div class="table">
        <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="businessRoulettes$"
            [isFilterable]="false" [paginator]="true" [scrollable]="true" (onLoadData)="onLoadData($event)" [isLoadLazy]="true"
            (sortChange)="onSort($event)"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="null">
        </app-readonly-table>
    </div>